module.exports = __webpack_public_path__ + "img/IndoorFireHydrant.80d50b5a.png";